var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrowNext",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 15 0)"
  }, /*#__PURE__*/React.createElement("style", null, "\n            #arrowNext:hover .circleIcon{\n              fill: #2A5FB3\n            }\n        "), /*#__PURE__*/React.createElement("circle", {
    className: "circleIcon",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#3374DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.308 2.308h10.384v10.384H2.308z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M10.962 7.067H5.696L8.114 4.65l-.614-.61L4.038 7.5 7.5 10.962l.61-.61-2.414-2.42h5.266z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/ArrowNext.6d7df5b33e5a3ee86664259a5302331a.svg";
export { ForwardRef as ReactComponent };